// extracted by mini-css-extract-plugin
module.exports = {"table":"index_table_1NrSP","head":"index_head_3K355","headItem":"index_headItem_2Istq","scroll":"index_scroll_1c-Mg","headIcon":"index_headIcon_N4vt6"};